import nBossConnection from 'modules/base/service/nBossConnection';

class PiWriterService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'piWriterControl';
	}

	/**
	 * @return {Promise<NamedDto[]>}
	 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @return {Promise<Object>}
	*/
	getInputAttributeNames(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getInputAttributeNames`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @param {Date} ts
	* @param {object} dataEntry
	* @return {Promise<Object>}
	*/
	writeDataEntry(id, ts, dataEntry) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/writeDataEntry`, { id, ts, dataEntry })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new PiWriterService();